// extracted by mini-css-extract-plugin
export default {"pretitle":"NotFoundPage_pretitle__8njPD"};